import {gql} from "@apollo/client";

export default gql`
  fragment SpeciesFragment on SpeciesParagraph {
    id
    title
    speciesCards {
      name
      iucnStatus
      url
    }
  }
`;
